<app-loader></app-loader>

<div class="layout-container" [ngClass]="containerClass">
   <app-sidebar></app-sidebar>
   <app-topbar style="background-color: rgb(45, 62, 80)"></app-topbar>
   <div class="layout-content-wrapper" style="border-top-left-radius: 2rem; background: #f5f9ff; padding-top: 2rem;">
      <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
      <div class="layout-content" style="padding-left: 2rem; padding-right: 2rem; border-radius: 2rem">
         <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
         <router-outlet></router-outlet>
      </div>
   </div>
   <app-profilemenu></app-profilemenu>
   <p-scrollTop [threshold]="500"></p-scrollTop>
</div>
